var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46362 1.71875L12.5261 10.3438C12.6902 10.6484 12.6902 11 12.5261 11.2812C12.3621 11.5859 12.0574 11.75 11.7292 11.75H1.60425C1.25269 11.75 0.947998 11.5859 0.783936 11.2812C0.619873 11 0.619873 10.6484 0.783936 10.3438L5.84644 1.71875C6.0105 1.4375 6.31519 1.25 6.66675 1.25C6.99487 1.25 7.29956 1.4375 7.46362 1.71875Z",
    fill: "#107F47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenUpArrow);
export default __webpack_public_path__ + "static/media/green_up_arrow.09f85a8185d015d732812a770048047c.svg";
export { ForwardRef as ReactComponent };